import type { UserSession } from '#auth-utils';

export const useUpdateSession = async (session: { session: { user: Partial<UserSession> } }) => {
  const { fetch } = useUserSession();

  try {
    await useFetchApi('/api/plataform/session/session', {
      method: 'PUT',
      body: session,
    });

    await fetch();
  } catch (error) {
    return error;
  }
};
